import { render } from "./InstallFf.vue?vue&type=template&id=5823413c&scoped=true"
import script from "./InstallFf.vue?vue&type=script&lang=js"
export * from "./InstallFf.vue?vue&type=script&lang=js"

import "./InstallFf.vue?vue&type=style&index=0&id=5823413c&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5823413c"]])

export default __exports__